import { useAuthentication } from '@ravago/shared/authentication';
import { hasPermissionToResource } from '@ravago/shared/next-data-access/client';
import { PermissionResources } from '@ravago/shared/page-data/models/features';

import { useQuery } from '@tanstack/react-query';

import { useFeatureToggle } from './use-feature-toggle';

export interface UsePermissionOptions {
   defaultValue: boolean;
}

const defaultOptions: UsePermissionOptions = {
   defaultValue: false
};

export const usePermission = (resource: PermissionResources, options?: Partial<UsePermissionOptions>) => {
   const { accessToken } = useAuthentication();
   const shouldUsePermissions = useFeatureToggle('show-permissions');

   const { defaultValue } = { ...defaultOptions, ...options };

   const { data, isLoading } = useQuery({
      queryKey: ['permissions', resource],
      queryFn: () => hasPermissionToResource(resource),
      enabled: !!accessToken && shouldUsePermissions
   });

   if (!shouldUsePermissions) {
      return { hasPermission: true, isLoading: false };
   }

   return { hasPermission: data ?? defaultValue, isLoading };
};
